/**
 * 表紙・特集商品選定依頼確認（担当バイヤー用）画面の依頼クラス
 *
 * @export RequestInfo
 * @class RequestInfo
 */
export class RequestInfo {
  constructor(
    public orderCode: string,
    public mediumType: string,
    public mediumTypeName: string,
    public buyerRequestId: string,
    public requestStatus: number,
    public requestStatusName: string,
    public requestType: number,
    public requestTypeName: string,
    public featureCode: string,
    public featureName: string,
    public featureDisplay: string,
    public classCode: string,
    public classCodeName: string,
    public classDisplay: string,
    public middleClassCode: string,
    public middleClassCodeName: string,
    public middleClassDispaly: string,
    public pCode: string,
    public guideGoodsName: string,
    public guideStandardName: string,
    public tagName: string,
    public thisTimeSupplyPrice: number,
    public pricePattern: number,
    public pricePatternName: string,
    public planNum: number,
    public planSupplyBudget: number,
    public dispPlanSupplyBudget: string,
    public thisTimeCostPrice: number,
    public gpr: number,
  ) {}
}
